// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import GuineaBissau from '../_raw/flag/icon_flag_guinea_bissau.png';

export default () => <img src={GuineaBissau} alt="GuineaBissau" />;
